import Profile from '@/modules/profile/Profile'
import { getUsageAndBalanceThunk } from '@/redux/slices/usageAndBalanceSlice'
import { useAppDispatch, useAppSelector } from '@/redux/store'
import { Stack } from 'expo-router'
import { useEffect } from 'react'
import { View } from 'react-native'

export default function ProfilePage() {
  const dispatch = useAppDispatch()
  const currentUserLoaded = useAppSelector(state => state.currentUser.loaded)
  const currentUser = useAppSelector(state => state.currentUser.user)
  const balance = useAppSelector(state => state.usageAndBalance.debitBalance.balance)
  const isOwnerOrAdmin = useAppSelector(state => state.currentUser.isOwnerOrAdmin)

  useEffect(() => {
    dispatch(getUsageAndBalanceThunk())
  }, [dispatch])

  if (!currentUserLoaded || !currentUser) {
    return null
  }

  return (
    <View style={{ flex: 1 }}>
      <Stack.Screen options={{ title: '我的' }} />
      <Profile currentUser={currentUser} balance={balance} isOwnerOrAdmin={isOwnerOrAdmin} />
    </View>
  )
}
